export default __webpack_public_path__ + "static/media/din2p-2.8cc8813a.png";